import { recieveCompanies } from "./reducer";
import { APIClient } from "../../../helpers/api_helper";
const api = new APIClient();

export const loadCompanies = () => async (dispatch, getState) => {

    try {
        const data = await api.get('/api/companies/get_options/')

        if (data) {
            dispatch(recieveCompanies(data));
        }
    } catch (error) {
        console.error('Unable to load companies!', error)
    }
};
